import React from "react";
import Header from "./Header";
import Contact from "./Contact";

const Team = () => {
  const teamMembers = [
    {
      name: "Egbunike Theodora",
      role: "Founder",
      description:
        "Driving the vision and operations of Swift Haven with a passion for women's empowerment and education.",
      image: "/assets/images/Theodora.webp",
      social: {
        linkedin: "https://www.linkedin.com/in/theodora-egbunike-746035294/",
        email: "mailto:egbunike@gmail.com",
      },
    },
    {
      name: "Kenza Coulibaly",
      role: "Co-founder",
      description:
        "Bringing innovative solutions and strategic thinking to address period poverty in Africa.",
      image: "/assets/images/kenza.webp",
      social: {
        linkedin: "https://www.linkedin.com/in/kenza-coulibaly-leilla-mady/",
        email: "mailto:kenzaleilla@gmail.com",
      },
    },
    {
      name: "Chidera Anele",
      role: "Head of Product & Technology",
      description:
        "Leading the technical development and innovation behind Swift Haven's digital solutions.",
      image: "/assets/images/Chidera.webp",
      social: {
        linkedin: "https://www.linkedin.com/in/chidera-anele/",
        email: "mailto:anelechidera4@gmail.com",
      },
    },
    {
      name: "Leslie R",
      role: "Marketing Lead",
      description:
        "Leading strategic marketing initiatives and brand development to amplify Swift Haven's mission and reach across Africa.",
      image: "/assets/images/Leslie.webp",
      social: {
        linkedin: "https://www.linkedin.com/in/leslie-r-632681331/",
        email: "mailto:l.rutabayir@alustudent.com",
      },
    },
    {
      name: "Grace Katunge Mulle",
      role: "Operations Team Lead",
      description:
        "Overseeing day-to-day operations and ensuring smooth execution of Swift Haven's programs and initiatives.",
      image: "/assets/images/Mulle.webp",
      social: {
        linkedin: "https://www.linkedin.com/in/grace-mulle-5a1211288/",
        email: "mailto:katushmulle@gmail.com",
      },
    },
    {
      name: "Simeon Akhigbe",
      role: "Designs Team Lead",
      description:
        "Leading creative design solutions and visual communication strategies to enhance Swift Haven's brand presence and user experience.",
      image: "/assets/images/Simeone.jpg",
      social: {
        linkedin: "https://www.linkedin.com/in/simeon-akhigbe-86ba03302/",
        email: "mailto:akhigbesimeon2@gmail.com",
      },
    },
    {
      name: "Holyseed Isoma",
      role: "Partenerships Lead",
      description:
        "Leading partnerships and collaborations to expand Swift Haven's reach and impact across Africa.",
      image: "/assets/images/Holyseed.webp",
      social: {
        linkedin: "https://www.linkedin.com/in/holyseed-isoma-7885422a4/",
        email: "mailto:h.isoma@alustudent.com",
      },
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Component */}
      <div className="bg-white py-[2rem] mb-[3rem] relative">
        {/* Abstract Design Element Overlay */}
        <div className="absolute bottom-0 left-0 right-0 z-10">
          <img
            src="/assets/images/Abstract-No-Bg2.jpg"
            alt="Abstract Design Overlay"
            className="w-full h-auto object-cover"
            style={{
              maxHeight: "120px",
              objectPosition: "center bottom",
            }}
          />
        </div>
      </div>
      <Header className="mt-3" />

      {/* Team Members Section */}
      <section className="max-w-7xl mx-auto px-4 py-16">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h1 className="text-3xl lg:text-4xl xl:text-5xl font-light text-swift-dark mb-4 font-generalSans">
            The Team
          </h1>
          <p className="text-lg text-gray-600 font-light font-generalSans">
            Meet the passionate individuals driving change and innovation at
            Swift Haven
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 text-center transition-all duration-300 hover:-translate-y-2 hover:shadow-xl w-[15rem]"
            >
              <div className="w-32 h-32 bg-swift-pink rounded-full mx-auto mb-4 flex items-center justify-center overflow-hidden transition-transform duration-300 hover:scale-110">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover rounded-full"
                />
              </div>

              <h3 className="text-l font-bold mb-0 font-generalSans">
                {member.name}
              </h3>
              <p className="text-swift-pink text-sm font-light uppercase tracking-wider mb-4 font-generalSans">
                {member.role}
              </p>

              <div className="flex justify-center gap-4">
                {member.social.linkedin && (
                  <a
                    href={member.social.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-swift-pink transition-colors duration-300 text-xl"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                  </a>
                )}
                {member.social.github && (
                  <a
                    href={member.social.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-swift-pink transition-colors duration-300 text-xl"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                    </svg>
                  </a>
                )}
                {member.social.twitter && (
                  <a
                    href={member.social.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-swift-pink transition-colors duration-300 text-xl"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                    </svg>
                  </a>
                )}
                {member.social.email && (
                  <a
                    href={member.social.email}
                    className="text-gray-600 hover:text-swift-pink transition-colors duration-300 text-xl"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact Component */}
      <div data-section="contact">
        <Contact />
      </div>
    </div>
  );
};

export default Team;
